// extracted by mini-css-extract-plugin
export default {"card":"style_card__Y0UjT","text":"style_text__XYCo5","button":"style_button__OmnhB"};